export function extractInformationFromNetworkRelationship(relationship) {
  const isClient = relationship.emitterOrganisationId === relationship.client.organisationId;
  return {
    invitingOrganisationName: isClient ? relationship.client.fullName : relationship.subcontractor.fullName,
    invitationId: relationship.relationshipId
  };
}
